import { NotificationAction } from './notification.actions';
import { NotificationTypes }from "./notification.types"

const notificationReducer = (state = null, action: NotificationAction) => {
    switch(action.type) {
        case NotificationTypes.CREATE_NOTIFICATION:
            if(!state) {
                return { ...action.payload }
            }
            return state

        case NotificationTypes.CLEAR_NOTIFICATION:
            return null

        default: 
            return state
    }
}

export default notificationReducer
